<script setup lang="ts">
import { computed, inject, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useBaseProfileStore } from '@/shared/stores/BaseProfileStore';
import { useBaseLawyerStore } from '@/shared/stores/BaseLawyerStore';
import { useBaseRatingStore } from '@/shared/stores/BaseRatingStore';
import { useGoogleAnalytics } from '@/shared/composables/googleAnalytics';
import { GA_ATRIBUTES } from '@/shared/constants/GoogleAnalytics';
import { TranslationHelper } from '@/shared/helper/TranslationHelper';
import { useProfileProductId } from '@/shared/stores/ProfileProductId';

const { t } = useI18n();
const { rating } = useBaseRatingStore();
const { uri, displayedName } = useBaseProfileStore();
const { profile } = useBaseLawyerStore();
const { dataAttributesGA, updateAttributeGA } = useGoogleAnalytics();
const { profileProductId } = useProfileProductId();
const { getTranslationByProductId, getGenderValueForTranslation } = TranslationHelper();

const giveRatingLink = inject('give-rating-link');
const giveRatingButton = inject('give-rating-button');
const GA_Label = inject('give-rating-ga-label');

const setRateButtonTitle = computed(() => {
  return (
    getTranslationByProductId('rateButtonTitle', profileProductId, { n: getGenderValueForTranslation(profile.sex) }) +
    ' ' +
    displayedName
  );
});

onMounted(() => {
  updateAttributeGA({
    [GA_ATRIBUTES.LABEL]: t(`${GA_Label}`),
    [GA_ATRIBUTES.ACTION]: t('eventActionSidebarClickGiveRatingButton'),
  });
});
</script>

<template>
  <a
    v-if="rating.isRateable"
    v-bind="dataAttributesGA"
    data-test-id="button-give-rating"
    class="grow md:grow-0 anw-btn anw-btn-primary-outline"
    :title="setRateButtonTitle"
    :href="`${uri}${giveRatingLink}`">
    {{ t(`${giveRatingButton}`) }}
  </a>
</template>
